// @flow

import { LOG_IN, LOG_OUT, INIT } from '../actionTypes';

export const logoutAction = () => ({
  type: LOG_OUT,
});

export const loginAction = () => ({
  type: LOG_IN,
});

export const initAction = () => ({
  type: INIT,
});
